import { FC, ReactElement } from 'react';

import { VisualCarouselInterface, VisualCarouselLayout } from '../../../entities/@sections/VisualCarousel/VisualCarousel';
import { FullWidthVisualCarousel, HalfWidthVisualCarousel } from './subcomponents';

interface VisualCarouselProps extends VisualCarouselInterface {
    className?: string;
}

const VisualCarousel: FC<VisualCarouselProps> = ({
    className = '',
    ...visualCarouselProps
}): ReactElement => {
    if (visualCarouselProps.layout === VisualCarouselLayout.halfWidth) {
        return (
            <HalfWidthVisualCarousel
                {...visualCarouselProps}
                className={className}
            />
        );
    }

    return (
        <FullWidthVisualCarousel
            {...visualCarouselProps}
            className={className}
        />
    );
};

export default VisualCarousel;
